import React from "react";
import acebitlogga from '../assets/AceBit4.png';
import LogoDark from "../assets/acebit-logo-white.svg";
import { FaLinkedin } from 'react-icons/fa';
import NavLink from "./navlink";

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (

        <footer className="bg-slate-700 shadow dark:bg-slate-900 text-white dark:text-gray-500">
            <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
                <div className="flex sm:flex-row flex-col sm:items-center sm:justify-between justify-center gap-4">
                    <div className="w-1/2">
                        <NavLink target="home">
                            <img src={LogoDark} alt="Logo" className="sm:w-[250px] w-[200px]" />
                        </NavLink>
                    </div>
                    <ul className="flex flex-wrap items-center text-sm font-medium sm:mb-0">
                        <li>
                            <a href="#" className="hover:underline me-4 md:me-6">Om oss</a>
                        </li>
                        <li>
                            <a href="#" className="hover:underline me-4 md:me-6">Tjänster</a>
                        </li>
                        <li>
                            <a href="#" className="hover:underline me-4 md:me-6">Karriär</a>
                        </li>
                        <li>
                            <a href="#" className="hover:underline">Kontakta oss</a>
                        </li>
                    </ul>
                </div>
                <hr className="my-4 border-gray-200 sm:mx-auto dark:border-gray-600 sm:my-8" />
                <div className="flex justify-between items-center sm:flex-row flex-col">
                    <span className="block text-sm  sm:text-center">
                        © 2024 <a href="https://acebit.se" target="_blank" className="hover:underline">Acebit</a>
                    </span>
                    <div className="flex items-center text-sm space-x-2">
                        <span>Besök oss:</span>
                        <a href="https://maps.app.goo.gl/BCnFEFJ8LLyMsw9q9" target="_blank" rel="noopener noreferrer" className="dark:text-blue-500 text-blue-300 hover:underline">Falun</a>
                        <a href="https://maps.app.goo.gl/hPpMDsCqvru7k7aM6" target="_blank" rel="noopener noreferrer" className="dark:text-blue-500 text-blue-300 hover:underline">Västerås</a>
                        <a href="https://maps.app.goo.gl/JyhzREq5PABrRaZC9" target="_blank" rel="noopener noreferrer" className="dark:text-blue-500 text-blue-300 hover:underline">Stockholm</a>
                    </div>
                    <a
                        href="https://www.linkedin.com/company/acebit"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:opacity-75 transition-opacity duration-200 mt-4 sm:mt-0"
                    >
                        <FaLinkedin size={24} />
                    </a>
                </div>
            </div>
        </footer>

    );
};
export default Footer;